// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accounts-row>div:nth-child(odd){border-radius:4px;background-color:var(--highlight-primary)}", ""]);
// Exports
module.exports = exports;
